import { Component, OnInit } from '@angular/core';
import { NotificationModel } from 'app/shared/models/notification.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'sc-policy-cancellation-details',
  templateUrl: './policy-cancellation-details.component.html',
  styleUrls: ['./policy-cancellation-details.component.scss']
})
export class PolicyCancellationDetailsComponent implements OnInit {

  data: NotificationModel;
  isLoading = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService) {

    // Forzamos a recargar la ruta cuando cambian los parametros
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    if (this.activatedRoute.snapshot.params.notificationId) {
      this.isLoading = true;
      this.notificationService.getNotificationById(this.activatedRoute.snapshot.params.notificationId)
        .subscribe(x => {
          this.isLoading = false;
          this.data = x;
        }, () => {
          this.isLoading = false;
        });
    }

  }

  ngOnInit() {
  }

}
